export default "<div>   \n    <router-outlet></router-outlet>\n</div>"